import React, { useEffect, useRef, useState } from 'react'
import PropTypes from 'prop-types'
import noop from 'lodash/noop'
import { connect } from 'react-redux'
import { Controller, useForm } from 'react-hook-form'
import { MaskedInput, createDefaultMaskGenerator } from 'react-hook-mask'
const phoneMask = createDefaultMaskGenerator('(999) 999-9999')
const cardnumbermask = createDefaultMaskGenerator('9999')
const expirymask = createDefaultMaskGenerator('99/99')
import 'react-toastify/dist/ReactToastify.css'
import 'react-datepicker/dist/react-datepicker.css'
import { Circles } from 'react-loader-spinner'
import { errorMessage } from '../../constants/errorMessage'
import { getQrTicketDetails, ticketValidation } from '../../redux/actions/ticketValidationAction'
import { EMPTY_ARRAY, EMPTY_OBJECT, getSvgIcon } from '../../constants/globalConstants'
import moment from 'moment/moment'
import MiniHeader from '../../components/global/MiniHeader'
import UpperHeader from '../../components/global/UpperHeader'
import { Col, Container, Form, ListGroup } from 'react-bootstrap'
import { useNavigate, useParams } from 'react-router-dom'
import { isLoggedIn, isOnlyHTML, isPermissionExist, isVehicleLimitExceeded, loggedInUserData, phoneMasker, sortPortalPermissionByKey } from '../../utils/helper'
import { postCardPaymentDetails } from '../../redux/actions/transientAction'
import { addEventLog } from '../../redux/actions/EventsLog'
import CONSTANTS from '../../redux/constants'
import VehicleHod from '../vehicle/VehicleHod'
import CommonListModal from '../../global/CommonListModal'
import { getVehilceData } from '../../redux/actions/VehicleAction'
import URL from '../../constants/urls'

function Hotel({...props }) {
  const { handleSubmit, control, formState: { errors }, reset, register } = useForm()
  const { dispatch, loader, notify, partnerDetails, vehicleDataProps } = props
  const qrcodeId = window.location.toString().split('/')[5]
  const [searchByLicense, setSearchByLicense] = useState(true)
  const [searchByPhone, setSearchByPhone] = useState(false)
  const [searchByTicket, setSearchByTicket] = useState(false)
  const [ticketDetails, setTicketDetails] = useState(EMPTY_OBJECT)
  const [searchByCard, setSearchByCard] = useState(false)
  const [isSubmittingForm, setIsSubmittingForm] = useState(false)
  const [hideStartParkingButtion, setStartParkingButtionHide] = useState(true)
  const [currentSelVehicle, setCurrentVehicle] = useState(EMPTY_OBJECT)
  const [isVehicleModalOpen, setIsVehicleModalOpen] = useState(false)
  const [isCommonModalOpen, setCommonModal] = useState(false)
  const [facilityData, setFacilityData] = useState(false)
  const [vehicleDataList, setVehicleDataList] = useState(EMPTY_ARRAY)

  const navigate = useNavigate()

  const targetRef = useRef(null)
  let { qrcode, partner } = useParams()

  useEffect(() => {
    const faciltyData = { 'facility': partnerDetails?.facilities?.[0] }
    setFacilityData(faciltyData)
  }, [])

  const handleScroll = () => {
    if (targetRef.current) {
      targetRef.current.scrollIntoView({ behavior: 'smooth' })
    }
  }

  useEffect(() => {
    if (isLoggedIn()) {
      updateCurrentVehicle()
    }
    localStorage.setItem('history', JSON.stringify({ route: 'h', facility: qrcode }))
    localStorage.setItem('faclityData', JSON.stringify(partnerDetails?.facilities?.[0]))
  }, [EMPTY_ARRAY, vehicleDataList])

  useEffect(() => {

    if (isLoggedIn()) {
        dispatch(getVehilceData()).then((res) => {
            setVehicleDataList(res?.data?.data)
        }).catch((err) => {
            notify('error', err?.errors?.message ? err?.errors?.message : errorMessage?.somethingWentWrong)
            let errObject = {
                payload: '',
                error: err,
                errorMessage: err?.errors?.message ? err?.errors?.message : errorMessage?.somethingWentWrong
            }
            dispatch(addEventLog(errObject, `${CONSTANTS?.UNEXPECTED_ERROR} getVehilceData-TransientForm.js-291`))
        })
    }

  },[EMPTY_ARRAY])
  
  useEffect(() => {
    setVehicleDataList(vehicleDataProps)
  },[EMPTY_ARRAY, vehicleDataProps])

  const onSubmit = (data) => {
    setTicketDetails(EMPTY_OBJECT)
    const urlIdentifier = window.location.toString().split('/')[4]
    let payload = {
      // phone: data?.phone ? data?.phone : '',
      // ticket: data?.ticket_number ? data?.ticket_number : '',
      business_qrcode: qrcodeId,
      // cardExpiry: data?.card_expiry,
      // cardLast4: data?.card_number,
      license_plate: data?.license,
      phone: data?.phone,
    }

    if (urlIdentifier == 'h') {
      payload = { ...payload, 'enabled_ticket_creation_flow': 1 }
    }

    if (data?.license) {

      dispatch(getQrTicketDetails(payload)).then((res) => {
        if (res?.status === 201 || res?.status === 200) {
          if (res?.data && res?.data != null) {
            if (res?.data == '' || res?.data?.is_closed == 1 || res?.data?.is_expired == 1) {
              createTicket(payload)
            } else {
              validateTicket(qrcodeId, res?.data?.ticket_number, false)
            }

          } else {
            notify(
              'error',
              res?.errors?.message
                ? res?.errors?.message
                : errorMessage?.somethingWentWrong
            )
          }
        } else {
          createTicket(payload)
          // notify( 'error', res?.errors?.message ? res?.errors?.message : errorMessage?.somethingWentWrong )
        }
      }).catch((err) => {
        notify('error', err?.errors?.message ? err?.errors?.message : errorMessage?.somethingWentWrong)
      })
    } else {
      notify('error', 'Please enter the license plate or add a new vehicle')
    }
  }

  const handleSearchByEvent = (e, search) => {
    setTicketDetails(EMPTY_OBJECT)
    const { checked } = e.target
    reset({
      phone: '',
      license: '',
      ticket_number: '',
      card_expiry: '',
      card_number: '',
    })
    setSearchByCard(false)
    setSearchByLicense(false)
    setSearchByPhone(false)
    setSearchByTicket(false)
    search == 'license' ? setSearchByLicense(true) : search == 'card' ? setSearchByCard(checked) : search == 'phone' ? setSearchByPhone(true) : setSearchByTicket(checked)
  }

  const validateTicket = (qrcodeId, ticketNumber, isTicketCreated) => {
    const payload = {
      'ticket_number': ticketNumber,
      channel: 'web',
      business_qrcode: qrcodeId,
      'enabled_ticket_creation_flow': 1,
      'user_type': isLoggedIn() ? 1 : 2
    }
    dispatch(ticketValidation(payload)).then((res) => {
      if (res?.status === 201 || res?.status === 200) {
        if (res?.data && res?.data?.paid_date != null) {
          setTicketDetails(res?.data)
          setIsSubmittingForm(false)
          setFacilityData(res?.data)
          navigate(`/${partner}${URL?.CONFIRMATION}/${res?.data?.ticket_number}`)
        }
        if (isTicketCreated) {
          notify('success', 'Your parking session has been successfully created and validated.')
        } else {
          notify('success', 'E-Ticket has been validated successfully.')
        }

        setStartParkingButtionHide(false)
        setIsSubmittingForm(false)
      } else {
        notify('error', res?.errors?.message ? res?.errors?.message : errorMessage?.somethingWentWrong)
        setIsSubmittingForm(false)
      }
    }).catch((err) => {
        notify('error', err?.errors?.message ? err?.errors?.message : errorMessage?.somethingWentWrong)
        setIsSubmittingForm(false)
    })
  }

  const createTicket = (data) => {
    setIsSubmittingForm(true)
    const finalPayload = {
      'license_plate': data?.license_plate,
      'phone': data?.phone,
      'enabled_ticket_creation_flow': 1,
      'device_type': 'web',
      'facility_id': partnerDetails?.facilities?.[0]?.id,
      'length': '0',
      business_qrcode: qrcodeId,
    }
    dispatch(postCardPaymentDetails(finalPayload)).then((res) => {
      if (res?.status === 201 && res?.data) {
        // Call Validate API
        validateTicket(qrcodeId, res?.data?.ticket_number, true)
      } else {
        // Display Error Message
        notify('error', res?.errors?.message ?res?.errors?.message : errorMessage?.somethingWentWrong)
        setIsSubmittingForm(false)
      }
    }).catch((err) => {
      setIsSubmittingForm(false)
      notify('error', err?.errors?.message ? err?.errors?.message : errorMessage?.somethingWentWrong)
      let errObject = { payload: finalPayload, error: err, errorMessage: err?.errors?.message ? err?.errors?.message : errorMessage?.somethingWentWrong }
      dispatch(addEventLog(errObject, `${CONSTANTS?.UNEXPECTED_ERROR} ticketCreation-hotel.js`))
    })
  }

  const handleAddVehilce = () => {
    if (!isSubmittingForm) {
      setIsVehicleModalOpen(!isVehicleModalOpen)
    }
  }

  const updateCurrentVehicle = () => {
    const filterobj = vehicleDataList?.filter((item) => item?.is_default == '1')
    setCurrentVehicle(filterobj?.[0] ?? EMPTY_OBJECT)
    handleCurrentSelection(filterobj?.[0])
  }

  const handleCommonListModal = () => {
    if (!isSubmittingForm) {
      if (vehicleDataList?.length > 0) {
        setCommonModal(!isCommonModalOpen)
      } else {
        handleAddVehilce()
      }
    }
  }

  const handleCurrentSelection = (item) => {
    reset(formValues => ({ ...formValues, 'license': item?.license_plate_number }))
    setCurrentVehicle(item)
  }

  return (
    <div className=''>
      <MiniHeader title='PARKING DETAILS' partnerDetails={partnerDetails} />
      <UpperHeader faciltyData={facilityData} totalHoursLength={facilityData?.length} partnerDetails={partnerDetails} />
      <div className='container-fluid'>
        {(partnerDetails && partnerDetails.bussiness_qr_deleted && partnerDetails.bussiness_qr_deleted != '') ? <div className="py-3 border-danger my-2">
          <div className='alert alert-danger' role="alert">
            {partnerDetails?.bussiness_qr_deleted}
          </div>
        </div> :
          <div>
            <form onSubmit={handleSubmit(onSubmit)}>
              <div className="row mt-4">
                <div className="col col-12 col-sm-12">
                  <label className="d-none mb-1">Search By</label>
                  <div className="row p-0 m-0">
                    <div className="d-none col-6 ms-0 me-0 pe-0 ps-0 d-flex align-items-center mb-2">
                      <input
                        style={{ width: '15px' }}
                        className='me-2'
                        type="checkbox"
                        disabled={loader}
                        checked={searchByCard}
                        onChange={(e) => handleSearchByEvent(e, 'card')}
                        data-toggle="toggle"
                        name='ab-1'
                      />
                      <label htmlFor="ab-1" className="form-check-label fw-normal" >Card Details</label>
                    </div>
                    <div className="d-none col-6 ms-0 me-0 pe-0 ps-0 d-flex align-items-center mb-2">
                      <input
                        style={{ width: '15px' }}
                        className='me-2'
                        type="checkbox"
                        disabled={loader}
                        checked={searchByPhone}
                        onChange={(e) => handleSearchByEvent(e, 'phone')}
                        data-toggle="toggle"
                        name='ab-1'
                      />
                      <label htmlFor="ab-1" className="form-check-label fw-normal" >Phone Number</label>
                    </div>
                    <div className="d-none col-6 ms-0 me-0 pe-0 ps-0 d-flex align-items-center mb-2">
                      <input
                        className='me-2'
                        type="checkbox"
                        style={{ width: '15px ' }}
                        disabled={loader}
                        checked={searchByTicket}
                        onChange={(e) => handleSearchByEvent(e, 'ticket')}
                        data-toggle="toggle"
                        name='ab-2'
                      />
                      <label htmlFor="ab-2" className="form-check-label fw-normal" >Ticket Number</label>
                    </div>
                    <div className="d-none col-6 ms-0 me-0 pe-0 ps-0 d-flex align-items-center mb-2">
                      <input
                        style={{ width: '15px' }}
                        className='me-2'
                        type="checkbox"
                        disabled={loader}
                        checked={searchByLicense}
                        onChange={(e) => handleSearchByEvent(e, 'license')}
                        data-toggle="toggle"
                        name='ab-1'
                      />
                      <label htmlFor="ab-1" className="form-check-label fw-normal" >License Plate</label>
                    </div>
                  </div>
                </div>
                {/* Display if Card Number Searching is Enabled */}
                {searchByCard ? (
                  <div className="col col-sm-12 col-12 ms-0 ps-2 me-0 pe-2">
                    <div className="form-group mb-2">
                      <label htmlFor="card_number">Card Information</label>
                    </div>
                    <div className="input-group form-group mb-2">
                      <Controller
                        name="card_number"
                        type="text"
                        id="card_number"
                        control={control}
                        // rules={{ required: (cardExpiry.length === 4 && cardNumber.length !== 4) ? true : false, maxLength: 4 }}
                        rules={{
                          required: {
                            value: true,
                            message: 'Card Number is required',
                          },
                          minLength: {
                            value: 4,
                            message: 'Minimum 4 characters allowed',
                          },
                          maxLength: {
                            value: 4,
                            message: 'Maximum 4 characters allowed',
                          },
                        }}
                        render={({ field }) => (
                          <MaskedInput
                            maskGenerator={cardnumbermask}
                            autoComplete="off"
                            pattern="[0-9 ]{4}"
                            maxLength="4"
                            {...field}
                            id="card_number"
                            title="Card no. should be 15-16 digit numberic"
                            className="form-control specialBorder"
                            onInvalid={(e) =>
                              e.target.setCustomValidity(
                                'Please enter a valid card number'
                              )
                            }
                            onInput={(e) => e.target.setCustomValidity('')}
                            placeholder="Last 4 digit"
                          // onChange={(event) => field.onChange(handleCardNumber(event))}
                          />
                        )}
                      />

                      {/* expiry input filled  */}
                      <Controller
                        name="card_expiry"
                        type="text"
                        id="card_expiry"
                        control={control}
                        // rules={{ required: (cardNumber.length === 4 && cardExpiry.length !== 4) ? true : false, maxLength: 5 }}
                        rules={{
                          required: {
                            value: true,
                            message: 'Card Expiry is required',
                          },
                          minLength: {
                            value: 4,
                            message: 'Minimum 4 characters allowed',
                          },
                          maxLength: {
                            value: 4,
                            message: 'Maximum 4 characters allowed',
                          },
                        }}
                        render={({ field }) => (
                          <MaskedInput
                            maskGenerator={expirymask}
                            autoComplete="off"
                            pattern="(?:0?[1-9]|1[0-2])/[0-9 ]{2}"
                            maxLength="5"
                            {...field}
                            id="card_expiry"
                            className="form-control"
                            onInvalid={(e) =>
                              e.target.setCustomValidity(
                                'Please enter mm/yy format card expiry date'
                              )
                            }
                            onInput={(e) => e.target.setCustomValidity('')}
                            placeholder="mm/yy"
                          // onChange={(event) => field.onChange(handleCardExpiry(event))}
                          />
                        )}
                      />
                    </div>
                    <div className='row'><div className='col-6 col-sm-6 pe-0 me-0'>{errors?.card_number && (
                      <span className="text-danger small">
                        {errors?.card_number?.message}
                      </span>
                    )}</div>
                      <div className='col-6 col-sm-6 ps-0 ms-0'>{errors?.card_expiry && (
                        <span className="text-danger small">
                          {errors?.card_expiry?.message}
                        </span>
                      )}</div></div>

                    {/* search by entry exit time */}




                    {/*end  search by entry exit time */}
                  </div>
                ) : /* Display if Phone Number Searching is Enabled */
                  searchByPhone ? (
                    <div className="col col-sm-12 col-12 ms-0 ps-2 me-0 pe-2">
                      <label className='form-group mb-2' htmlFor="card_number">Phone Number</label>
                      <div className="input-group mb-2">
                        <Controller
                          name="phone"
                          type="text"
                          id="phone"
                          control={control}
                          rules={{
                            required: {
                              value: true,
                              message: 'This field is required',
                            },
                            minLength: {
                              value: 10,
                              message: 'Minimum 10 characters allowed',
                            },
                            maxLength: {
                              value: 10,
                              message: 'Maximum 10 characters allowed',
                            },
                          }}
                          render={({ field }) => (
                            <MaskedInput
                              maskGenerator={phoneMask}
                              autoComplete="off"
                              maxLength="14"
                              {...field}
                              id="phone"
                              title="Phone number should be 10 digit numberic"
                              className="form-control"
                              onInvalid={(e) =>
                                e.target.setCustomValidity(
                                  'Please enter a valid phone number'
                                )
                              }
                              onInput={(e) => e.target.setCustomValidity('')}
                              placeholder="Phone Number"
                            // onChange={(event) => field.onChange(handlePhoneNumber(event))}
                            />
                          )}
                        />
                      </div>
                      {errors?.phone && (
                        <span className="text-danger small">
                          {errors?.phone?.message}
                        </span>
                      )}
                    </div>
                  ) : searchByTicket ? (
                    <div className="col col-sm-12 col-12 ms-0 ps-2 me-0 pe-2">

                      <label className='form-group mb-2' htmlFor="card_number">Ticket Number</label>

                      <div className="input-group mb-2">

                        <Controller
                          name="ticket_number"
                          type="text"
                          id="ticket_number"
                          control={control}
                          rules={{
                            required: {
                              value: true,
                              message: 'This field is required',
                            },
                            pattern: {
                              value: /^[a-zA-Z0-9\s]*$/,
                              message: 'Please enter valid ticket number'
                            },
                            minLength: {
                              value: 8,
                              message: 'Minimum 8 characters allowed',
                            },
                            maxLength: {
                              value: 11,
                              message: 'Maximum 11 characters allowed',
                            },
                          }}
                          render={({ field }) => (
                            <input
                              type={'text'}
                              autoComplete="off"
                              className="form-control"
                              {...field}
                              id="ticket_number"
                              placeholder="Ticket Number"
                              maxLength={11}
                              minLength={6}

                            // onChange={(event) => field.onChange(handlePhoneNumber(event))}
                            />
                          )}
                        />
                      </div>
                      {errors?.ticket_number && (
                        <span className="text-danger small">
                          {errors?.ticket_number?.message}
                        </span>
                      )}
                    </div>
                  ) : (!isLoggedIn()) ? <div className="col col-sm-12 col-12 ms-0 ps-2 me-0 pe-2">

                    <label className='form-group mb-2' htmlFor="card_number">License Plate <span className='text-danger'>*</span></label>

                    <div className="input-group mb-2">

                      <Controller
                        name="license"
                        type="text"
                        id="license"
                        control={control}
                        rules={{
                          required: {
                            value: true,
                            message: 'This field is required',
                          },
                          minLength: {
                            value: 2,
                            message: 'Minimum 2 characters allowed',
                          },
                          maxLength: {
                            value: 10,
                            message: 'Maximum 10 characters allowed',
                          },
                        }}
                        render={({ field }) => (
                          <input
                            type={'text'}
                            autoComplete="off"
                            className="form-control"
                            {...field}
                            id="license"
                            placeholder="License Plate Number"
                            maxLength={10}
                            minLength={2}
                            disabled={!hideStartParkingButtion}
                          // onChange={(event) => field.onChange(handlePhoneNumber(event))}
                          />
                        )}
                      />
                    </div>
                    {errors?.license && (
                      <span className="text-danger small">
                        {errors?.license?.message}
                      </span>
                    )}
                    <div className="col col-sm-12 col-12 ms-0 me-0">
                      <label className='form-group mb-2' htmlFor="card_number">Phone Number</label>
                      <div className="input-group mb-2">
                        <Controller
                          name="phone"
                          type="text"
                          id="phone"
                          control={control}
                          rules={{
                            minLength: {
                              value: 10,
                              message: 'Minimum 10 characters allowed',
                            },
                            maxLength: {
                              value: 10,
                              message: 'Maximum 10 characters allowed',
                            },
                          }}
                          render={({ field }) => (
                            <MaskedInput
                              maskGenerator={phoneMask}
                              autoComplete="off"
                              maxLength="14"
                              {...field}
                              id="phone"
                              title="Phone number should be 10 digit numberic"
                              className="form-control"
                              onInvalid={(e) =>
                                e.target.setCustomValidity(
                                  'Please enter a valid phone number'
                                )
                              }
                              onInput={(e) => e.target.setCustomValidity('')}
                              placeholder="Phone Number"
                            // onChange={(event) => field.onChange(handlePhoneNumber(event))}
                            />
                          )}
                        />
                      </div>
                      {errors?.phone && (
                        <span className="text-danger small">
                          {errors?.phone?.message}
                        </span>
                      )}
                    </div>
                  </div> : null}

                {/* the vehicle section for log-in user  */}
                {(isLoggedIn()) ?
                  <div className='col col-sm-12 col-12 ms-0 ps-2 me-0 pe-2'>
                    <label className='VehilceLables d-flex justify-content-between align-items-start cursor'>Vehicle Details {(!isVehicleLimitExceeded(sortPortalPermissionByKey(partnerDetails, 'Restricted Permissions'), vehicleDataList, partnerDetails?.max_vehicle)) ? <span onClick={handleAddVehilce}><i className='fa fa-plus small'></i> Add New Vehicle</span> : null}</label>
                    <ListGroup className={`cursor ${!hideStartParkingButtion ? 'disabled' : ''}`} as="ol" onClick={() => handleCommonListModal('Vehicle')} style={{ pointerEvents: hideStartParkingButtion ? 'auto' : 'none' }}>
                      <ListGroup.Item as="li" className="d-flex justify-content-between align-items-start">
                        <span style={{ height: '23px', width: '23px' }}>{getSvgIcon('Car', 'var(--bs-primary)')}</span>
                        <div className="ms-2 me-auto listVehicleGroupItem">{currentSelVehicle?.license_plate_number}</div>
                        <i className='fa fa-caret-down mt-1' style={{ fontSize: '13px' }}></i>
                      </ListGroup.Item>
                    </ListGroup>
                  </div> : null}
                {/* section end */}

                <div className="col col-sm-12 col-12 ms-0 ps-2 me-0 pe-2  mt-1">
                  {(((facilityData?.facility?.facility_configuration?.terms_condition_content && facilityData?.facility?.facility_configuration?.terms_condition_content != '') || (partnerDetails?.brand_setting?.terms_condition_content && partnerDetails?.brand_setting?.terms_condition_content != '')) && isPermissionExist(sortPortalPermissionByKey(partnerDetails, 'Restricted Permissions'), 'Display Terms & Conditions Checkbox')) ? <Col className="m-2">
                    <Form.Group className="d-flex">
                      <input
                        type="checkbox"
                        id='termsnconds'
                        name='termsnconds'
                        {...register('termsnconds', {
                          required: { value: (((facilityData?.facility?.facility_configuration?.terms_condition_content && facilityData?.facility?.facility_configuration?.terms_condition_content != '') || (partnerDetails?.brand_setting?.terms_condition_content && partnerDetails?.brand_setting?.terms_condition_content != '')) && isPermissionExist(sortPortalPermissionByKey(partnerDetails, 'Restricted Permissions'), 'Display Terms & Conditions Checkbox')) ? true : false, message: 'Please accept the Terms and Conditions' },
                        })}
                        className='me-2'
                        style={{ 'width': 'auto' }}
                      />
                      <Form.Label className='d-flex align-items-center text-primary fw-normal mb-0 styleLables'>I have read and agreed to the <span className="fw-bold" onClick={() => { handleScroll() }}>Terms and Conditions</span> <span className='text-danger'>*</span></Form.Label>

                    </Form.Group>
                    {errors?.termsnconds && <Form.Text className="text-danger header-s">{errors?.termsnconds?.message}</Form.Text>}
                  </Col> : null}


                  {(hideStartParkingButtion) ? <button type="submit" name="submit" className="btn bg-primary text-white mt-4 w-100" onClick={handleSubmit} disabled={(loader || isSubmittingForm)}>
                    {' '}
                    <div className="d-flex justify-content-center align-items-center">
                      <span>Start Parking</span>
                      <span className="ms-2">
                        {(loader || isSubmittingForm) ? (
                          <Circles
                            height="20"
                            width="20"
                            style={{ display: 'inline-block' }}
                            color="#ffffff"
                            ariaLabel="circles-loading"
                            visible={true}
                          />
                        ) : null}
                      </span>
                    </div>
                  </button> : null}
                </div>
              </div>
            </form>

            {(Object.keys(ticketDetails)?.length > 0) && <div className='card card-body mt-3 shadow'>
              <div className=' row'>
                <div className=' col-6 col-sm-3 mb-3'>
                  <small className='fw-bold text-secondary'>Customer Name</small>
                  <p>{(ticketDetails?.user && ticketDetails?.user?.name) ? ticketDetails?.user?.name : loggedInUserData()?.user?.name ? loggedInUserData()?.user?.name : '-'}</p>
                </div>

                <div className=' col-6 col-sm-3 mb-3'>
                  <small className='fw-bold text-secondary'>Ticket Number</small>
                  <p>{(ticketDetails && ticketDetails?.ticket_number) ? ticketDetails?.ticket_number : '-'}</p>
                </div>

                <div className=' col-6 col-sm-3 mb-3'>
                  <small className='fw-bold text-secondary'>Phone Number</small>
                  <p>{(ticketDetails?.user && ticketDetails?.user?.phone_number) ? phoneMasker(ticketDetails?.user?.phone_number?.replace(/[^\d]+/g, '').slice(-10)) : loggedInUserData()?.user?.phone_number ? phoneMasker(loggedInUserData()?.user?.phone_number) : '-'}</p>
                </div>

                <div className=' col-6 col-sm-3 mb-3'>
                  <small className='fw-bold text-secondary'>License Plate</small>
                  <p>{(ticketDetails && ticketDetails?.license_plate) ? ticketDetails?.license_plate : '-'}</p>
                </div>

                <div className=' col-6 col-sm-3 mb-3'>
                  <small className='fw-bold text-secondary'>Check-In Time</small>
                  <p>{ticketDetails ? ticketDetails?.checkin_time ? moment(ticketDetails?.checkin_time).format('MM/DD/YYYY h:mm A') : '-' : '-'}</p>
                </div>

                <div className=' col-6 col-sm-3 mb-3'>
                  <small className='fw-bold text-secondary'>Check-Out Time</small>
                  <p>{ticketDetails ? ticketDetails?.checkout_time ? moment(ticketDetails?.checkout_time).format('MM/DD/YYYY h:mm A') : '-' : '-'}</p>
                </div>

                <div className=' col-6 col-sm-3 mb-3'>
                  <small className='fw-bold text-secondary'>Validated  On</small>
                  <p>{ticketDetails?.paid_date ? moment(ticketDetails?.paid_date).format('MM/DD/YYYY h:mm A') : '-'}</p>
                </div>

                <div className=' col-12'>
                  <small className='fw-bold text-secondary'>Validated  Remark</small>
                  <p>{ticketDetails?.paid_remark ? ticketDetails?.paid_remark : '-'}</p>
                </div>
              </div>
            </div>}

            <div>
              {(partner == 'usmparking' || partner == 'usm') ? <div className='px-2'><a href='https://usm.maine.edu/parking-services/' target='_blank' rel="noopener noreferrer" style={{ color: 'blue' }} className="small m-0"><i className='fa fa-link'></i> Access Options/Where to Park/Rules </a></div> : ''}
              {(facilityData?.facility?.facility_configuration?.terms_condition_content && facilityData?.facility?.facility_configuration?.terms_condition_content != '' && !isOnlyHTML(facilityData?.facility?.facility_configuration?.terms_condition_content)) || (partnerDetails?.brand_setting?.terms_condition_content && partnerDetails?.brand_setting?.terms_condition_content != '' && !isOnlyHTML(partnerDetails?.brand_setting?.terms_condition_content)) ?
                <Container className='p-0 mt-5'>
                  <div ref={targetRef} className="mt-2 p-2 card" dangerouslySetInnerHTML={{ __html: facilityData?.facility?.facility_configuration?.terms_condition_content ? facilityData?.facility?.facility_configuration?.terms_condition_content : partnerDetails?.brand_setting?.terms_condition_content }} />
                </Container> :
                null}
            </div>
          </div>
        }
      </div>
      <VehicleHod isVehicleModalOpen={isVehicleModalOpen} setIsVehicleModalOpen={setIsVehicleModalOpen} notify={notify} isInTransient />
      <CommonListModal setCommonModal={setCommonModal} isCommonModalOpen={isCommonModalOpen} listData={vehicleDataList} isThisVehicleModal={true} register={register} handleCurrentSelection={handleCurrentSelection} currentSelVehicle={currentSelVehicle} />
    </div>
  )
}

Hotel.propTypes = {
  dispatch: PropTypes.func,
  loader: PropTypes.bool,
  isPageOpen: PropTypes.bool,
  notify: PropTypes.func,
  qrCodeData: PropTypes.object,
  partnerDetails: PropTypes.object,
  vehicleDataProps: PropTypes.array,
}

Hotel.defaulProps = {
  dispatch: noop,
  loader: false,
  notify: noop,
  partnerDetails: EMPTY_OBJECT,
  vehicleDataProps: EMPTY_ARRAY,
}

function mapStateToProps({ userDetailsReducer, VehilceReducer }) {
  const { partnerDetails, loader, qrCodeData } = userDetailsReducer
  const { data } = VehilceReducer
  return {
    loader: loader,
    qrCodeData: qrCodeData,
    vehicleDataProps: data?.data?.data ?? EMPTY_ARRAY,
    partnerDetails: partnerDetails?.data
  }
}
export default connect(mapStateToProps)(Hotel)

